import "@css/Loader.css";
import PropTypes from "prop-types";
import MenuSkeleton from "./MenuSkeleton";

/**
 * FullPageLoader - компонент полноэкранной загрузки (включая меню)
 * Используется для начальной загрузки приложения, авторизации и т.д.
 * @param {string} text - Текст загрузки (по умолчанию: "Загрузка...")
 */
const FullPageLoader = ({ text = "Загрузка..." }) => {
    return (
        <div className="full-page-loader">
            <MenuSkeleton />
            <div className="loader-content">
                <div className="loader-spinner" />
                <p className="loader-text">{text}</p>
            </div>
        </div>
    );
};

FullPageLoader.propTypes = {
    text: PropTypes.string,
};

export default FullPageLoader;
